import styled from 'styled-components'
import { getBGColor } from 'utils/themeUtils'

const BambuserWrapper = styled.div`
  background: ${getBGColor()};
  div {
    .channel {
      background: ${getBGColor()};
    }
  }
`

export default BambuserWrapper
